module.exports = __webpack_public_path__ + "static/media/LifeDlogoWhite.ae96b859.png";